module.exports = __webpack_public_path__ + "static/img/Invalides.4b152a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Invalides.jpg
// module id = x88B
// module chunks = 0